import { useEffect, useMemo, useState } from "react";
import { callautopopulate } from "../../../services/callautopop";
import { useEmployeFilter } from "../../../context/EmployeFilterContext";
import _ from "underscore";
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import { useLocation, useNavigate } from "react-router-dom";
import { useRegularityPanel } from "./useRegularityPanel";

export const useEmployeeDetail = () => {

    const { selectedEmployee, setSelectedEmployee } = useEmployeFilter();
    const [users, setUsers] = useState([]);
    const [viewProfileDialog, setViewProfileDialog] = useState(false);
    const [loader, setLoader] = useState(false);
    const [employeeData, setEmployeeData] = useState({});
    const [skills, setSkills] = useState("")
    const location = useLocation();
    const [isLeadDashboard] = useState(location?.pathname?.includes("lead-dashboard"));
    const [loggedInUser, setLoggedInUser] = useState(null);
    const navigate = useNavigate();
    const {puncJson} = useRegularityPanel();
    const [punctualityData] = useState(_.groupBy(puncJson, "title"));
    const [userImage, setUserImage] = useState("");

    useEffect(() => {
        callautopopulate("users", "user_info", "project_leads").then(res => {
            if(isLeadDashboard) {
                setUsers(res?.project_leads?.sort((a, b) => a.user_display_name?.localeCompare(b.user_display_name)));
                setSelectedEmployee(_.findWhere(res?.project_leads, { user_code: location?.state?.selectedEmployee ? location?.state?.selectedEmployee?.user_code : res?.user_info?.[0]?.user_code }));
                setLoggedInUser(_.find(res?.project_leads, { user_code: res?.user_info?.[0]?.user_code }));
                navigate(location.pathname, { replace: true });
            } else {
                const users = (res?.users)?.map((item) => { return { ...item, user_display_name: item?.user_display_location_name } })?.sort((a, b) => a?.user_display_name?.localeCompare(b?.user_display_name));
                setUsers(users);
                setSelectedEmployee(_.find(users, { user_code: res?.user_info?.[0]?.user_code }));
                setLoggedInUser(_.find(users, { user_code: res?.user_info?.[0]?.user_code }));
            }
        });

        return ()=>{
            setSelectedEmployee({})
        }
    }, [])

    useEffect(() => {
        selectedEmployee?.user_code && getEmployeeDetails(selectedEmployee?.user_code)
    }, [selectedEmployee?.user_code])

    useEffect(() => {
        if (!employeeData?.image_url) {
            setUserImage("/assets/grey-user-icon.png");
            return;
        }
        const img = new Image();
        const url = `${employeeData.image_url}?cache=${Date.now()}`;
        img.onload = () => { setUserImage(url); };
        img.onerror = () => { setUserImage("/assets/grey-user-icon.png"); };
        img.src = url;
    }, [employeeData?.image_url]);



    // Api calling for get employee details
    const getEmployeeDetails = async (usecode) => {
        try {
            setLoader(true)
            let payload = {
                "project_ids": "",
                "reporting_employee_id": "",
                "from_date": "",
                "to_date": "",
                "users": usecode.toString(),
                "criteria_key": ""
            }
            const res = await services.getInvokeRemote('POST', Urls('GETTEAMOVERVIEWLIST'), payload)
            setLoader(false)
            if (res.body.data?.team_data) {
                const data = res.body.data.team_data[0]
                setEmployeeData(data)
                const skillString = data?.secondary_skill_1 ? `${data?.primary_skill_1 || ""}, ${data?.secondary_skill_1 || ""}` : data?.primary_skill_1;
                setSkills(skillString)
            } else {
                console.error(res.body.message);
            }
        } catch (error) {
            setLoader(false)
            console.error(error, "error");
        }
    }

    return useMemo(() => ({
        users, viewProfileDialog, setViewProfileDialog, employeeData, loader, getEmployeeDetails, skills, loggedInUser, isLeadDashboard, punctualityData, userImage, setUserImage
    }), [users, viewProfileDialog, setViewProfileDialog, employeeData, loader, getEmployeeDetails, skills, loggedInUser, isLeadDashboard, punctualityData, userImage, setUserImage])
}